import { render, staticRenderFns } from "./EditableBdcCard.vue?vue&type=template&id=4dc4c68a&scoped=true"
import script from "./EditableBdcCard.vue?vue&type=script&lang=js"
export * from "./EditableBdcCard.vue?vue&type=script&lang=js"
import style0 from "./EditableBdcCard.vue?vue&type=style&index=0&id=4dc4c68a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc4c68a",
  null
  
)

export default component.exports